// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__ENK73","content":"Consent_content__1MWg_","footer":"Consent_footer__1o_Rm"};